import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListVendors from './ListVendors';
import NewVendor from './NewVendor';
import PrintVendors from './PrintVendors';
import Reports from './Reports';
import Loader from '../../Loader';

export default function Vendors() {
  return (<div>
    <Routes>
      <Route path="/" element={<ListVendors />} />
      <Route path="/print" element={<PrintVendors />} />
      <Route path="/new" element={<NewVendor />} />
      <Route path="/reports" element={<Reports />} />
    </Routes>
  </div>);

}
